import { render, staticRenderFns } from "./WaktuLive.vue?vue&type=template&id=085028a7&scoped=true&"
import script from "./WaktuLive.vue?vue&type=script&lang=js&"
export * from "./WaktuLive.vue?vue&type=script&lang=js&"
import style0 from "./WaktuLive.vue?vue&type=style&index=0&id=085028a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085028a7",
  null
  
)

export default component.exports